// Events - Data source
// Upcoming events and curated experiences

export interface Event {
  id: string;
  title: string;
  date: string;
  description: string;
  image: string;
  category: string;
}

export const upcomingEvents: Event[] = [
  {
    id: "chile-ski-season",
    title: "Chile Ski Season Opening",
    date: "June 2025",
    description:
      "Join us for the opening of the ski season at La Parva and Valle Nevado. Experience pristine snow conditions and exclusive access to the best terrain.",
    image: "https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=800&q=80",
    category: "Skiing",
  },
  {
    id: "patagonia-fly-fishing",
    title: "Patagonia Fly Fishing Expedition",
    date: "November 2025",
    description:
      "An exclusive fly fishing experience in the pristine waters of Chilean Patagonia. Target brown trout and rainbow trout in stunning wilderness settings.",
    image: "https://images.unsplash.com/photo-1544552866-d3ed42536cfd?w=800&q=80",
    category: "Fishing",
  },
  {
    id: "heli-skiing-week",
    title: "Heli-Skiing Adventure Week",
    date: "July 2025",
    description:
      "Experience world-class heli-skiing in the Andes. Access remote peaks and untouched powder with our expert guides and private helicopter service.",
    image: "https://images.unsplash.com/photo-1551524164-687a55dd1126?w=800&q=80",
    category: "Heli-Skiing",
  },
  {
    id: "wellness-yoga-retreat",
    title: "Wellness & Yoga Retreat",
    date: "March 2026",
    description:
      "Rejuvenate your body and mind at our exclusive mountain retreat. Featuring daily yoga sessions, spa treatments, and gourmet healthy cuisine.",
    image: "https://images.unsplash.com/photo-1506126613408-eca07ce68773?w=800&q=80",
    category: "Wellness",
  },
  {
    id: "mountain-biking-festival",
    title: "Mountain Biking Festival",
    date: "February 2026",
    description:
      "Join fellow biking enthusiasts for an epic mountain biking festival. Explore the best trails in the Andes with guided tours and expert coaching.",
    image: "https://images.unsplash.com/photo-1511994298241-608e28f14fde?w=800&q=80",
    category: "Biking",
  },
  {
    id: "photography-expedition",
    title: "Photography Expedition",
    date: "September 2025",
    description:
      "Capture the breathtaking landscapes of Patagonia with renowned nature photographers. Learn advanced techniques while experiencing stunning locations.",
    image: "https://images.unsplash.com/photo-1452421822248-d4c2b47f0c81?w=800&q=80",
    category: "Photography",
  },
];
